module.exports = __webpack_public_path__ + "img/IMG_8931.162f2921.jpg";